module.exports = __webpack_public_path__ + "static/media/industries.1aa8bb9c.png";